import { render } from "./JobsByWorkerPieChart.vue?vue&type=template&id=6a88b3be&ts=true"
import script from "./JobsByWorkerPieChart.vue?vue&type=script&lang=ts"
export * from "./JobsByWorkerPieChart.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__